import { combineReducers, configureStore, type Action } from '@reduxjs/toolkit';

import { loggedOut } from './actions';
import { userReducer } from './userSlice';
import { ordersReducer } from './ordersSlice';
import { calendarReducer } from './calendarSlice';
import { dispatchersReducer } from './dispatchersSlice';
import { usersReducer } from './usersSlice';
import { placesReducer } from './placesSlice';

const appReducer = combineReducers({
  user: userReducer,
  orders: ordersReducer,
  calendar: calendarReducer,
  dispatchers: dispatchersReducer,
  users: usersReducer,
  places: placesReducer,
});

// One name for the shape (LOW-1): `RootState` below is derived from the store,
// which is derived from this reducer — so there is no second, drifting alias.
type CombinedState = ReturnType<typeof appReducer>;

// Whole-store reset on logout: `undefined` state makes every slice fall back to
// its own initial state, so no slice added later can forget to clear itself.
// (`userSlice` then latches `status: 'loggedOut'` on top — a slice's own
// `extraReducers` still run after the `undefined` fallback.)
export const rootReducer = (
  state: CombinedState | undefined,
  action: Action,
): CombinedState => appReducer(action.type === loggedOut.type ? undefined : state, action);

export const store = configureStore({ reducer: rootReducer });

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { loggedOut } from './actions';
